"use strict";

var _classCallCheck = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Queue = void 0;

var Queue = /*#__PURE__*/function () {
  /**
   * A really simple queue with concurrency.
   *
   * @param {Function} worker
   * @param {Object} options
   * @param {!number} options.concurrency
   */
  function Queue(worker) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Queue);

    this._worker = worker;
    this._concurrency = options.concurrency || 1;
    this.tasks = [];
    this.total = 0;
    this.active = 0;
  }
  /**
   * Push a task to the queue.
   *
   *  @param {T} item
   *  @param {!Function} callback
   */


  _createClass(Queue, [{
    key: "push",
    value: function push(item, callback) {
      this.tasks.push({
        item: item,
        callback: callback
      });
      this.total++;

      this._next();
    }
    /**
     * Process next job in queue.
     */

  }, {
    key: "_next",
    value: function _next() {
      var _this = this;

      if (this.active >= this._concurrency || !this.tasks.length) {
        return;
      }

      var _this$tasks$shift = this.tasks.shift(),
          item = _this$tasks$shift.item,
          callback = _this$tasks$shift.callback;

      var callbackCalled = false;
      this.active++;

      this._worker(item, function (err, result) {
        if (callbackCalled) {
          return;
        }

        _this.active--;
        callbackCalled = true;
        callback === null || callback === void 0 ? void 0 : callback(err, result);

        _this._next();
      });
    }
    /**
     * Stops processing queued jobs.
     */

  }, {
    key: "die",
    value: function die() {
      this.tasks = [];
    }
  }]);

  return Queue;
}();

exports.Queue = Queue;